import {
  AlignCenter,
  AlignJustify,
  AlignLeft,
  AlignRight,
  ArrowDownAZ,
  ArrowLeft,
  ArrowLeftFromLine,
  ArrowLeftToLine,
  ArrowRight,
  ArrowRightFromLine,
  ArrowRightToLine,
  ArrowsUpFromLine,
  ArrowUp,
  ArrowUpDown,
  ArrowUpRight,
  ArrowUpZA,
  Atom,
  AtSign,
  Bell,
  Bold,
  BookOpenCheck,
  Box,
  Brackets,
  Brain,
  BrushCleaning,
  Building2,
  Calendar,
  ChartNoAxesColumn,
  Check,
  ChevronDown,
  ChevronFirst,
  ChevronLast,
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
  ChevronsUp,
  ChevronsUpDown,
  ChevronUp,
  Circle,
  CircleAlert,
  CircleCheck,
  CircleDashed,
  CircleDot,
  CircleEllipsis,
  CircleQuestionMark,
  CircleSmall,
  CircleUserRound,
  CircleX,
  Clock4,
  CloudUpload,
  Code,
  Copy,
  createLucideIcon,
  CreditCard,
  Crop,
  Diamond,
  Dices,
  Download,
  Ellipsis,
  EllipsisVertical,
  Eraser,
  ExternalLink,
  Eye,
  EyeOff,
  File,
  FilePlus2,
  Folder,
  FolderPlus,
  Gauge,
  Gift,
  GitCommitHorizontal,
  GitCommitVertical,
  GitMerge,
  GitPullRequestArrow,
  GitPullRequestDraft,
  Grid2X2,
  Grid3X3,
  GripVertical,
  Hash,
  Headphones,
  Image,
  Info,
  Italic,
  Keyboard,
  KeyRound,
  Layers2,
  LayoutGrid,
  Link,
  Link2,
  List,
  ListChecks,
  ListFilter,
  ListOrdered,
  LoaderCircle,
  Lock,
  LogOut,
  MessageSquare,
  Mic,
  Minus,
  MonitorPlay,
  Moon,
  MousePointer2,
  MousePointerClick,
  MoveDiagonal,
  MoveHorizontal,
  MoveUpRight,
  Package,
  PaintbrushVertical,
  PaintBucket,
  PanelLeft,
  PanelsTopLeft,
  Paperclip,
  Pause,
  Pencil,
  PencilLine,
  Play,
  Plus,
  Quote,
  RectangleEllipsis,
  RectangleHorizontal,
  Redo2,
  RemoveFormatting,
  Repeat,
  RotateCcw,
  Rows2,
  Scan,
  ScanSearch,
  Scissors,
  Search,
  SearchCheck,
  SearchCode,
  Send,
  Server,
  Settings,
  Shapes,
  Shuffle,
  Sigma,
  Slice,
  SlidersHorizontal,
  Smile,
  Sparkles,
  Spline,
  Split,
  Square,
  SquareDashed,
  SquareMousePointer,
  SquarePlus,
  SquareSigma,
  SquaresUnite,
  Star,
  Strikethrough,
  Tag,
  Tags,
  Trash,
  Trees,
  TrendingUp,
  TriangleAlert,
  Type,
  Underline,
  Undo2,
  Unlink,
  UserRound,
  UserRoundPlus,
  UsersRound,
  VectorSquare,
  Video,
  VideoOff,
  Wand,
  Webhook,
  Wrench,
  X,
} from 'lucide-vue-next'

import { beachBall, centCircle, crosshair2, typeSquare } from '@lucide/lab'
import { instanceId } from './custom/icons'

const BeachBall = createLucideIcon('BeachBall', beachBall)
const CentCircle = createLucideIcon('CentCircle', centCircle)
const Crosshair2 = createLucideIcon('Crosshair2', crosshair2)
const TypeSquare = createLucideIcon('TypeSquare', typeSquare)
const InstanceId = createLucideIcon('InstanceId', instanceId)

export const icons = {
  'duotone-status-dataset': LayoutGrid,
  'mono-view-grid': LayoutGrid,
  'duotone-workflow': GitPullRequestArrow,
  'mono-workflow': GitPullRequestArrow,
  'mono-workflow-unlinked': GitPullRequestDraft,
  'duotone-workflow-stage': GitCommitVertical,
  'fill-small-tagactive': Tag,
  'mono-tag': Tag,
  'duotone-tag': Tag,
  'duotone-tag-double': Tags,
  'duotone-status-model': Brain,
  'mono-report': ChartNoAxesColumn,
  'mono-ai-assisted-review-stage': ListChecks,
  'duotone-comment': MessageSquare,
  'duotone-changelog': Gift,
  'duotone-video': MonitorPlay,
  'duotone-audio': Headphones,
  'duotone-document': File,
  'duotone-add-person': UserRoundPlus,
  'duotone-settings': Settings,
  'duotone-admin': Wrench,
  'mono-collapse-left': ChevronFirst,
  'mono-collapse-right': ChevronLast,
  ellipsis: RectangleEllipsis,
  'mono-notification-bell': Bell,
  'fill-small-drag': GripVertical,
  'fill-small-caret-right': ChevronRight,
  'fill-small-check': Check,
  'fill-small-dot': CircleSmall,
  'fill-small-chevron-down': ChevronDown,
  'fill-small-chevron-top': ChevronUp,
  'fill-small-hide': EyeOff,
  'fill-small-info': Info,
  'fill-play': Play,
  'fill-resume': Pause,
  'fill-checked-circled': CircleCheck,
  'fill-cross-circled': CircleX,
  'mono-unify': SquaresUnite,
  'mono-scissors': Scissors,
  'mono-slice': Slice,
  'mono-layout-left': PanelLeft,
  'mono-set-end-frame': ArrowRightToLine,
  'mono-set-start-frame': ArrowLeftToLine,
  'mono-repeat': Repeat,
  'mono-resize-left': ChevronsLeft,
  'mono-resize-right': ChevronsRight,
  'mono-dice': Dices,
  'mono-sigma': Sigma,
  'mono-layer-group': Layers2,
  'mono-add-folder': FolderPlus,
  'mono-arrow-left': ArrowLeft,
  'mono-arrow-right': ArrowRight,
  'mono-arrow-top-right': ArrowUpRight,
  'mono-arrow-up': ArrowUp,
  'mono-attribute': Hash,
  'mono-calendar': Calendar,
  'mono-centroid': CircleSmall,
  'mono-check': Check,
  'mono-chevron-down': ChevronDown,
  'mono-chevron-left': ChevronLeft,
  'mono-chevron-right': ChevronRight,
  'mono-chevron-up': ChevronUp,
  'mono-chevron-selector-vertical': ChevronsUpDown,
  'mono-close': X,
  'mono-directional-vector': MoveUpRight,
  'mono-dots-horizontal': Ellipsis,
  'mono-dots-vertical': EllipsisVertical,
  'mono-download': Download,
  'mono-edit': Pencil,
  'mono-export': ExternalLink,
  'mono-filter': ListFilter,
  'mono-folder': Folder,
  'mono-hide': EyeOff,
  'mono-measurements': MoveDiagonal,
  'mono-show': Eye,
  'mono-idle': CircleDashed,
  'mono-info': Info,
  'mono-instance-id': InstanceId,
  'mono-keyboard': Keyboard,
  'mono-keyframe': Diamond,
  'mono-link': Link2,
  'mono-lock': Lock,
  'mono-mic': Mic,
  'mono-minus': Minus,
  'mono-pause': Pause,
  'mono-person': UserRound,
  'mono-play': Play,
  'mono-plus': Plus,
  'mono-preserve-zoom-false': SearchCode,
  'mono-preserve-zoom-true': SearchCheck,
  'mono-priority': ChevronsUp,
  'mono-radiocheck': CircleCheck,
  'mono-sort': ArrowUpDown,
  'mono-search': Search,
  'mono-reset': RotateCcw,
  'mono-skelleton': GitMerge,
  'mono-step-back': Undo2,
  'mono-step-forward': Redo2,
  'mono-stop': Square,
  'mono-table-class': Grid2X2,
  'mono-text': TypeSquare,
  'mono-timer': Clock4,
  'mono-trash': Trash,
  'mono-view-full': RectangleHorizontal,
  'mono-view-list': List,
  'mono-wand': Wand,
  'mono-warning': TriangleAlert,
  'mono-workspace': Building2,
  transparent: SquareDashed,
  'skip-previous': ChevronsLeft,
  'skip-next': ChevronsRight,
  'duotone-brush-emtpy-only': BrushCleaning,
  'duotone-brush': PaintbrushVertical,
  'duotone-erase-all': SquareDashed,
  'duotone-erase': Eraser,
  'duotone-parallel-blind-stage': ArrowsUpFromLine,
  'duotone-status-webhook': Webhook,
  'duotone-auto-track-region': Brackets,
  'duotone-auto-track-forward': ArrowRightFromLine,
  'duotone-auto-track-backward': ArrowLeftFromLine,
  'duotone-auto-track-full': MoveHorizontal,
  'duotone-auto-tracking': TrendingUp,
  'duotone-layer-group': Layers2,
  'duotone-sync-video-playback': Link,
  'duotone-out-of-view': VideoOff,
  'duotone-in-view': Video,
  'duotone-3dsphere': BeachBall,
  'duotone-darkmode': Moon,
  'duotone-singleselect': CircleDot,
  'duotone-multiselect': List,
  'duotone-status-consensus': Atom,
  'duotone-status-sampling': Shuffle,
  'duotone-credit-card': CreditCard,
  'duotone-add-folder': FolderPlus,
  'duotone-attribute': Hash,
  'duotone-bounding-box': Square,
  'duotone-calendar': Calendar,
  'duotone-circle': Circle,
  'duotone-coin': CentCircle,
  'duotone-copy': Copy,
  'duotone-cuboid': Box,
  'duotone-directional-vector': MoveUpRight,
  'duotone-edit': Pencil,
  'duotone-full': Square,
  'duotone-hide': EyeOff,
  'duotone-idle': CircleDashed,
  'duotone-image-manipulation': SlidersHorizontal,
  'duotone-image': Image,
  'duotone-in-progress': CircleEllipsis,
  'duotone-info': Info,
  'duotone-instance-id': InstanceId,
  'duotone-key': KeyRound,
  'duotone-keyboard-shortcut': Keyboard,
  'duotone-keyframe': Diamond,
  'duotone-line': Spline,
  'duotone-loading': LoaderCircle,
  'duotone-lock': Lock,
  'duotone-magic-selection': MousePointerClick,
  'duotone-object-detection': Scan,
  'duotone-performance-test': Gauge,
  'duotone-person-circle': CircleUserRound,
  'duotone-person': UserRound,
  'duotone-persons': UsersRound,
  'duotone-point': Crosshair2,
  'duotone-polygon': VectorSquare,
  'duotone-question': CircleQuestionMark,
  'duotone-raster': Grid3X3,
  'duotone-search': Search,
  'duotone-send': Send,
  'duotone-server': Server,
  'duotone-show': Eye,
  'duotone-signout': LogOut,
  'duotone-skelleton': GitMerge,
  'duotone-sort-ascending': ArrowDownAZ,
  'duotone-sort-descending': ArrowUpZA,
  'duotone-star': Star,
  'duotone-status-being-annotated': PencilLine,
  'duotone-status-complete': CircleCheck,
  'duotone-status-in-review': BookOpenCheck,
  'duotone-status-logic': Split,
  'duotone-status-new': Sparkles,
  'duotone-status-sum': SquareSigma,
  'duotone-table-class': Grid2X2,
  'duotone-text': TypeSquare,
  'duotone-timer': Clock4,
  'duotone-trash': Trash,
  'duotone-upload': CloudUpload,
  'duotone-view-folder': Folder,
  'duotone-warn': TriangleAlert,
  'duotone-workspace': Building2,
  'icon-fill': PaintBucket,
  'icon-crosshairs': SquarePlus,
  'icon-mouse-pointer': MousePointer2,
  'icon-window-level': Rows2,
  'icon-model-auto-annotate': MousePointerClick,
  'icon-model-auto-annotate-bounding-box': SquareMousePointer,
  'icon-model-classification': Shapes,
  'icon-model-instance-segmentation': Trees,
  'icon-model-object-detection': Package,
  'icon-model-text-scanner': TypeSquare,
  'icon-file-plus': FilePlus2,
  'icon-crop': Crop,
  'icon-zoom': ScanSearch,
  'icon-at-sign': AtSign,
  'icon-smile': Smile,
  'icon-connect': GitCommitHorizontal,
  'icon-rad-view-layout': PanelsTopLeft,
  'icon-warning': CircleAlert,
  'icon-link': Link,
  'icon-unlink': Unlink,

  'editor-bold': Bold,
  'editor-italic': Italic,
  'editor-underline': Underline,
  'editor-strikethrough': Strikethrough,
  'editor-code': Code,
  'editor-list-bullet': List,
  'editor-list-ordered': ListOrdered,
  'editor-blockquote': Quote,
  'editor-horizontal-rule': Minus,
  'editor-link': Link,
  'editor-image': Image,
  'editor-paperclip': Paperclip,
  'editor-undo': Undo2,
  'editor-redo': Redo2,
  'editor-chevron-down': ChevronDown,
  'editor-type': Type,
  'editor-paint-bucket': PaintBucket,
  'editor-clear-format': RemoveFormatting,
  'editor-align-left': AlignLeft,
  'editor-align-center': AlignCenter,
  'editor-align-right': AlignRight,
  'editor-align-justify': AlignJustify,
}

export type IconNames = keyof typeof icons
